export default __webpack_public_path__ + "atomic/_patterns/04-templates/node/_full-node-template.twig";